import * as React from "react";
import { toINR } from "../../../../service/numberFormat";
import { marginFnoHeading } from "../../marginConstants";
import { ISortProps } from "../../../../types/components/margin/marginTypes";
import MarginSort from "../../generic/marginSort";
import { marginScrollService } from "../../../../service/marginFiles/marginScrollService";

export interface IMarginFnoTableMobProps {
	tableData: Array<any>;
	filteredData: Array<any>;
	numOfRows: number;
	sortProps: ISortProps;
	setTableData: (tableData: Array<any>) => void;
}

const MarginFnoTableMob: React.FC<IMarginFnoTableMobProps> = props => {
	const scrollBodyRef = React.useRef<HTMLUListElement>(null);
	const fixedBodyRef = React.useRef<HTMLUListElement>(null);
	const scrollHeadRef = React.useRef<HTMLUListElement>(null);

	return (
		<div className="mrgn_fno_tbl margin_table_mob">
			<div className="fixed_col">
				<ul className="hdr_row">
					<li className="tr">
						<div className="td">
							<span className="sort_cont trdSym">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="trdSym"
									onSort={props.sortProps.onSort}
									colName={marginFnoHeading.trdSym}
								/>
							</span>
						</div>
					</li>
				</ul>
				<ul className="data_rows" ref={fixedBodyRef}>
					{props.tableData.slice(0, props.numOfRows).map((row, index) => (
						<li className="tr" key={index}>
							<div className="td">
								<span className="trdSym ib" dangerouslySetInnerHTML={{ __html: row.trdSym }}></span>
							</div>
						</li>
					))}
				</ul>
			</div>

			<div className="scrolling_cont">
				<ul className="hdr_row" ref={scrollHeadRef}>
					<li className="tr">
						<div className="td">
							<span className="sort_cont Mlot">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="Mlot"
									onSort={props.sortProps.onSort}
									colName={marginFnoHeading.mlot}
								/>
							</span>
						</div>
						<div className="td">
							<span className="sort_cont SpanMarginPerLot">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="SpanMarginPerLot"
									onSort={props.sortProps.onSort}
									colName={marginFnoHeading.spanMarginPerLot}
								/>
							</span>
						</div>
						<div className="td">
							<span className="sort_cont ExpMarginPerLot">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="ExpMarginPerLot"
									onSort={props.sortProps.onSort}
									colName={marginFnoHeading.expMarginPerLot}
								/>
							</span>
						</div>
						<div className="td">
							<span className="sort_cont TotalMarginPerLot">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="TotalMarginPerLot"
									onSort={props.sortProps.onSort}
									colName={marginFnoHeading.totalMarginPerLot}
								/>
							</span>
						</div>
						<div className="td">
							<span className="sort_cont RoundOff">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="RoundOff"
									onSort={props.sortProps.onSort}
									colName={marginFnoHeading.roundOff}
								/>
							</span>
						</div>
					</li>
				</ul>
				<ul className="data_rows" ref={scrollBodyRef} onScroll={() => marginScrollService(scrollBodyRef, fixedBodyRef, scrollHeadRef)}>
					{props.tableData.slice(0, props.numOfRows).map((row, index) => (
						<li className="tr" key={index}>
							<div className="td">
								<span className="Mlot ib">{toINR(row.Mlot)}</span>
							</div>
							<div className="td">
								<span className="SpanMarginPerLot ib">
									{toINR(row.SpanMarginPerLot)}
									<span className="row_2">({toINR(row.SPANMarginper)}%)</span>
								</span>
							</div>
							<div className="td">
								<span className="ExpMarginPerLot ib">
									{toINR(row.ExpMarginPerLot)}
									<span className="row_2">({toINR(row.ExpMarginper)}%)</span>
								</span>
							</div>
							<div className="td">
								<span className="TotalMarginPerLot ib">
									{toINR(row.TotalMarginPerLot, 2)}
									<span className="row_2">({toINR(row.TotalMarginper)}%)</span>
								</span>
							</div>
							<div className="td">
								<span className="RoundOff ib">{toINR(row.RoundOff)}</span>
							</div>
						</li>
					))}
				</ul>
			</div>
		</div>
	);
};

export default MarginFnoTableMob;
